import { StopType } from 'harmony-constants';
import { Stop } from '../../../types';
import { travelTimesCacheKey } from '../../../utils/data-mapping-utils';
import { TravelTimesCache } from '../../travel-times/use-travel-times';

export const useLadenUnladen = (stops: Stop[], travelTimesCache: TravelTimesCache | undefined, homeDriverLocationId: number | undefined) => {
    let ladenMeters = 0;
    let unladenMeters = 0;
    let currentWeight = 0;
    let currentQuantity = 0;

    if (homeDriverLocationId) {
        const homeToFirst = (travelTimesCache?.[travelTimesCacheKey([homeDriverLocationId, stops[0].organizationLocationId])]?.distanceMeters || 0);
        const lastToHome = (travelTimesCache?.[travelTimesCacheKey([stops[stops.length - 1].organizationLocationId, homeDriverLocationId])]?.distanceMeters || 0);
        unladenMeters += homeToFirst + lastToHome;
    }

    stops.forEach((currStop, stopIndex) => {
        if (stopIndex === 0) return;
        const prevStop = stops[stopIndex - 1];

        if (prevStop.type === StopType.Origin) {
            currentWeight += prevStop.weight || 0;
            currentQuantity += prevStop.quantity || 0;
        } else if (prevStop.type === StopType.Destination) {
            currentWeight -= prevStop.weight || 0;
            currentQuantity -= prevStop.quantity || 0;
        }

        const metersFromPrevToCurr = travelTimesCache?.[travelTimesCacheKey([prevStop.organizationLocationId, currStop.organizationLocationId])]?.distanceMeters || 0;
        if (currentWeight > 0 || currentQuantity > 0) {
            ladenMeters += +metersFromPrevToCurr;
        } else {
            unladenMeters += +metersFromPrevToCurr;
        }
    });

    return { ladenMeters, unladenMeters };
}